import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getTicketTypeById, getTicketTypeInfosByTicketTypeId } from "ticketino-api-client";

import Header from "./components/Header";
import Footer from "./components/Footer";

import imgIconProgressCompleted from "../images/progress-bar/ball-completed.svg";
import imgIconProgress from "../images/progress-bar/ball-progress.svg";

import imgIconInfo from "../images/icons/info.svg";

const Overview = () => {
    const [orderId] = useState(sessionStorage.getItem("orderId"));
    const [token] = useState(sessionStorage.getItem("token"));

    const [order, setOrder] = useState({});
    const [tickets, setTickets] = useState([]);

    const [eventIdWorkshopsSaturday, setEventIdWorkshopsSaturday] = useState();
    const [eventIdWorkshopsSunday, setEventIdWorkshopsSunday] = useState();

    const [totalSelectedWorkshopsSaturday, setTotalSelectedWorkshopsSaturday] = useState(0);
    const [totalSelectedWorkshopsSunday, setTotalSelectedWorkshopsSunday] = useState(0);

    const [countSaturdayTickets] = useState(sessionStorage.getItem("countSaturdayTickets"));
    const [countSundayTickets] = useState(sessionStorage.getItem("countSundayTickets"));

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        // gtm - addPaymentInfo
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'addPaymentInfo'
        });
    }, [])

    useEffect(() => {
        if (!tickets || !eventIdWorkshopsSaturday || !eventIdWorkshopsSunday) return;
        setTotalSelectedWorkshopsSaturday(tickets.filter(t => t.ticketType?.eventId === eventIdWorkshopsSaturday).length);
        setTotalSelectedWorkshopsSunday(tickets.filter(t => t.ticketType?.eventId === eventIdWorkshopsSunday).length);
    }, [tickets, eventIdWorkshopsSaturday, eventIdWorkshopsSunday])

    useEffect(() => {
        requestResources();
        requestFormSettings();
    }, [language]); //everytime language is changed

    useEffect(() => {
        if (order.tickets && order.tickets.length === 0) {
            navigate(`/${language}/home`);
        }
    }, [tickets]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        if (orderId) {
            loadOrder(orderId);
        }
    }, [orderId]); //gets called when an order is started

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const requestFormSettings = async () => {
        try {
            const res = await axios.get(`form/formsettings`);
            setEventIdWorkshopsSaturday(res.data.eventIdWorkshopsSaturday)
            setEventIdWorkshopsSunday(res.data.eventIdWorkshopsSunday)
        } catch (error) {
            console.error(error);
        }
    };

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);

                    const info = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo }
                })
            )

            setOrder(updatedOrder);
            setTickets(updatedTickets);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const onSubmit = async () => {
        navigate(`/${language}/checkout`);
    }

    const onBackClick = async () => {
        navigate(-1)
    }

    const removeTicketFromBasket = (id) => {
        let deleteBody = {
            ticketsToRemove: [id],
        };

        axios
            .delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                headers: {
                    Accept: "application/json",
                },
                data: deleteBody,
            })
            .then(() => loadOrder(orderId));
    }

    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    const formatDay = (isoString) => {
        const date = new Date(isoString);
        return String(date.getDate()).padStart(2, '0') + '.';
    };

    const mapTickets = () => {
        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.id - b.id);
        }

        return (
            tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((tt, index) => {
                // Check if this is a workshop ticket (EventId 214329 or 214330)
                const isWorkshopTicket = tt.ticketType?.eventId === eventIdWorkshopsSaturday || tt.ticketType?.eventId === eventIdWorkshopsSunday;
                const displayPrice = isWorkshopTicket ? tt.ticketTypePrice + 15.00 : tt.ticketTypePrice;
                const isWeekendTicket = ["weekend", "wochenend"].some(k => tt.info?.name?.toLowerCase().includes(k));

                return (
                    <div key={tt.id}>
                        <div className="mt-3">
                            {isWeekendTicket
                                ? <>{formatDay(tt.ticketType?.start)} - {formatDateTime(tt.ticketType?.end)}</>
                                : formatDateTime(tt.ticketType?.start)
                            }
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center flex-nowrap">
                                <label className="ticket-name-label mb-0">
                                    1x {tt.info?.name}
                                </label>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                                <label className="text-nowrap mb-0">
                                    {tt.ticketType?.currency} {displayPrice.toFixed(2)}
                                </label>
                                <button
                                    className="btn btn-link p-0 m-0 text-decoration-none"
                                    onClick={() => removeTicketFromBasket(tt.id)}
                                    aria-label="Remove ticket"
                                    style={{ outline: 'none', boxShadow: 'none' }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="19"
                                        height="19"
                                        fill="none"
                                        stroke="#4F5054"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        viewBox="0 0 24 24"
                                        style={{ marginTop: '-2px' }}
                                    >
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })
        );
    };

    return (
        <>
            <Header language={language} pagePath="overview" />
            <div className="page-container">
                {/* progress bar */}
                <div className="progressbar-wrapper">
                    <div className="progressbar-lines">
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                    </div>

                    <div className="progressbar-steps">
                        <div className="progress-step completed cursor-pointer" onClick={() => navigate(`/${language}/home`)}>
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 1" />
                            </div>
                            <div className="label">{resources?.ProgressTickets}</div>
                        </div>

                        <div className={`progress-step completed${countSaturdayTickets > 0 || countSundayTickets > 0 ? " cursor-pointer" : ""}`} onClick={() => {
                            if (countSaturdayTickets > 0) {
                                navigate(`/${language}/workshops-saturday`);
                            } else if (countSundayTickets > 0) {
                                navigate(`/${language}/workshops-sunday`);
                            }
                        }}>
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 2" />
                            </div>
                            <div className="label">
                                {resources?.ProgressWorkshops}<br />{resources?.ProgressOptional}
                            </div>
                        </div>

                        <div className="progress-step completed cursor-pointer" onClick={() => navigate(`/${language}/address`)}>
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 3" />
                            </div>
                            <div className="label">{resources?.ProgressAdditionalInformation}</div>
                        </div>

                        <div className="progress-step active">
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 4" />
                            </div>
                            <div className="label">{resources?.ProgressCheckout}</div>
                        </div>
                    </div>
                </div>

                <div className="container wrapper">

                    <div className="row fw-bold text-pink mt-5">
                        <div className="d-flex align-items-start">
                            <img src={imgIconInfo} alt="Increase" width="18" height="18" className="me-2" />
                            <span>{resources?.OverviewDescription}</span>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12">
                            <span className="text-subtitle">{resources?.OverviewTitle}</span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            {mapTickets()}
                        </div>
                    </div>

                    {(totalSelectedWorkshopsSaturday > 0 || totalSelectedWorkshopsSunday > 0) && (
                        <>
                            <hr className="ticket-separator" />

                            <div className="row mt-1">
                                <div className="col-md-8 col-8">
                                    <span>{resources?.DiscountOnEntranceTicket}</span>
                                </div>
                                <div className="col-md-4 col-4 text-end">
                                    <span>- {order.currency} {((totalSelectedWorkshopsSaturday + totalSelectedWorkshopsSunday) * 15).toFixed(2)}</span>
                                </div>
                            </div>
                        </>
                    )}

                    <hr className="ticket-separator" />

                    <div className="row mt-2">
                        <div className="col-6">
                            <span className="text-subtitle">{resources?.OverviewTotal}</span>
                        </div>
                        <div className="col-6 text-end">
                            <span className="text-subtitle">
                                {order.currency} {order.total?.toFixed(2)}
                            </span>
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="row mt-4">
                        <div className="col-6">
                                <button className="btn btn-custom" onClick={() => onBackClick()}>{resources?.Back}</button>
                        </div>
                        <div className="col-6 text-end">
                            <button className="btn btn-custom" onClick={() => onSubmit()}>{resources?.Next}</button>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-12 text-center">
                            <p className="mt-4">
                                <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer language={language} pagePath="home" />
        </>
    )
}

export default Overview